import React, { useState } from "react";
import images from "../../utils/images";
import { logOut } from "../../services/authService";
import webSocket from "../../services/onlineSocketService";
import { logoutUser } from "../../utils/localStorageUtils";
import { Navigate, useNavigate } from "react-router-dom";
import { deleteToken } from "firebase/messaging";
import { messaging } from "../../firebase/firebase";
import { isAuthenticated } from "../../utils/authenticated";

const Unauthorized = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  const handleDelete = async () => {
    setLoading(true);

    try {
      const success = await deleteToken(messaging);
      if (success) {
        await logOut();
        webSocket.disconnect(); // Disconnect WebSocket
        logoutUser(); // Clear localStorage/session
        navigate("/login");
        window.location.reload();
      }
    } catch (error) {
      console.error("Logout API failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
        padding: "20px",
      }}
    >
      <div style={{ width: "500px", marginBottom: "30px" }}>
        <img
          src={images.unauthrize}
          alt="Unauthorized"
          style={{ width: "100%", height: "auto" }}
        />
      </div>

      <p
        style={{
          fontSize: "1.2rem",
          color: "#6c757d",
          marginBottom: "30px",
          maxWidth: "500px",
        }}
      >
        Oops! The page you're looking for doesn't exist or you don't have access
        to it.
      </p>

      <button
        onClick={handleDelete}
        disabled={loading}
        style={{
          padding: "10px 25px",
          fontSize: "1rem",
          backgroundColor: loading ? "#6c757d" : "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: loading ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          transition: "background-color 0.3s",
        }}
        onMouseOver={(e) =>
          !loading && (e.currentTarget.style.backgroundColor = "#0056b3")
        }
        onMouseOut={(e) =>
          !loading && (e.currentTarget.style.backgroundColor = "#007bff")
        }
      >
        {loading ? (
          <>
            <span
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid white",
                borderTop: "2px solid transparent",
                borderRadius: "50%",
                display: "inline-block",
                animation: "spin 0.6s linear infinite",
              }}
            ></span>
            Logging Out...
          </>
        ) : (
          "Go Back"
        )}
      </button>

      {/* Inline Spinner Animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Unauthorized;
